import { createSelector } from 'reselect'
import { LabFeatureFlags } from 'constants/lab'
import { resolveLoyaltyChooseDoubleRewardsMetadata } from '../utils/loyaltyChooseDoubleRewardsMetadata'

const getLoyaltyChooseDoubleRewardsCampaignMetadata = createSelector(
  (state: App.State) => state.system.features.labFlags[LabFeatureFlags.enableSiteTakeoverMetadata],
  resolveLoyaltyChooseDoubleRewardsMetadata,
)

export default getLoyaltyChooseDoubleRewardsCampaignMetadata
